"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _kansaResultActions = require("../kansaResult/kansaResultActions");
var _kansaResultReferActions = require("../kansaResultRefer/kansaResultReferActions");
var _kansaResultRegisterActions = require("../kansaResultRegister/kansaResultRegisterActions");
var _kansaTargetRegisterActions = require("../kansaTargetRegister/kansaTargetRegisterActions");
var _kansaAnswerActions = require("../kansaanswer/kansaAnswerActions");
var _kansaProgressActions = require("../progress/kansaProgressActions");
var _kansaReportActions = require("../report/kansaReportActions");
var _kansaTargetListActions = require("../targetlist/kansaTargetListActions");
var _kansaConditionActions = require("./kansaConditionActions");
const kansaReducers = {
  kansaResult: _kansaResultActions.kansaResultReducer,
  kansaResultRegister: _kansaResultRegisterActions.kansaResultRegisterReducer,
  kansaResultRefer: _kansaResultReferActions.kansaResultReferReducer,
  kansaTargetRegister: _kansaTargetRegisterActions.kansaTargetRegisterReducer,
  kansaShareCondition: _kansaConditionActions.kansaConditionReducer,
  kansaProgress: _kansaProgressActions.kansaProgressReducer,
  kansaTargetList: _kansaTargetListActions.kansaTargetListReducer,
  kansaReport: _kansaReportActions.kansaReportReducer,
  kansaAnswer: _kansaAnswerActions.kansaAnswerReducer
};
var _default = exports.default = kansaReducers;